import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  pagination: {
    padding: 0,
    '& .MuiTablePagination-toolbar': {
      padding: 0,
      fontSize: '12px'
    },
    '& .MuiTablePagination-actions': {
      margin: 0,
      '& button': {
        padding: 0
      }
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
      fontSize: '12px'
    },
    '& .MuiTablePagination-input': {
      fontSize: '12px'
    }
  }
});

export default function Pagination({
  pageNumber,
  limit,
  handleChangePage,
  handleChangeRowsPerPage,
  pageCount
}) {
  const classes = useStyles();
  return (
    <TablePagination
      data-testid="table-pagination"
      component="div"
      count={pageCount}
      page={pageNumber}
      onPageChange={handleChangePage}
      rowsPerPage={limit}
      onRowsPerPageChange={handleChangeRowsPerPage}
      className={classes.pagination}
    />
  );
}
